import {
    LogoutOutlined,
    SettingOutlined,
    UserOutlined
} from '@ant-design/icons';
import { Avatar, Dropdown, Space, notification } from 'antd';
import { Link } from 'react-router-dom';

function MenuDropDown({ navigate, kernel, user }) {
    const displayName = user?.firstName && user?.lastName
        ? `${user.firstName} ${user.lastName}`
        : user?.email || 'User';

    const initials = user?.firstName && user?.lastName
        ? `${user.firstName[0]}${user.lastName[0]}`.toUpperCase()
        : displayName[0]?.toUpperCase() || 'U';

    const items = [
        {
            label: <Link to="/account/information">Preferences</Link>,
            key: 'account.information',
            icon: <SettingOutlined />
        },
        {
            type: 'divider'
        },
        {
            label: 'Logout',
            key: 'disconnect',
            icon: <LogoutOutlined />,
            danger: true
        }
    ];

    const onClick = ({ key }) => {
        if (key === 'disconnect') {
            notification.success({
                message: 'Disconnected',
                description: 'Your session has been closed'
            });
            kernel.session.store('');
            navigate('/session/login');
            return;
        }

        const path = key.split('.').join('/');
        navigate(`/${path}`);
    };

    return (
        <Dropdown
            overlayClassName="menu_account"
            trigger={['click']}
            menu={{ items, onClick }}
            placement="bottomRight"
        >
            <a
                className="ant-menu-title-content"
                onClick={(e) => e.preventDefault()}
                style={{ 
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <Space>
                    <Avatar
                        size="small"
                        style={{
                            backgroundColor: '#7eb022',
                            fontSize: 12
                        }}
                    >
                        {initials}
                    </Avatar>
                    <span style={{
                        fontWeight: 500,
                        maxWidth: 150,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                    }}>{displayName}</span>
                </Space>
            </a>
        </Dropdown>
    );
}

export default MenuDropDown;